import React, { type ReactNode } from 'react';
import { ProfileAvatar } from '@/shared/features/user-avatar';
import { type UserProfileProps } from '../types';
import { ProfileUserInfo } from './ProfileUserInfo';
import { ProfileContainer, ProfileContent } from './ProfileWidget';
type ProfileCardProps = {
  /** 카드 상단 띠. 없으면 ProfileContent 상단 패딩으로 보정한다. */
  banner?: ReactNode;
  user: UserProfileProps;
  actions: ReactNode;
};

/**
 * 프로필 카드의 공통 껍데기.
 *
 * MyProfile(/myquiz)과 UserProfile(/profile/[userHashId])은 배너와 액션 버튼만
 * 다르고 레이아웃이 같다. 둘이 서로 다른 레이어(page / shared)에 살기 때문에
 * 껍데기를 여기 한 곳에 두지 않으면 조용히 어긋난다.
 */
export const ProfileCard = ({
  banner,
  user,
  actions
}: ProfileCardProps) => {
  const hasBanner = Boolean(banner);
  return <ProfileContainer data-sentry-element="ProfileContainer" data-sentry-component="ProfileCard" data-sentry-source-file="ProfileCard.tsx">
      {banner}
      <ProfileContent className={hasBanner ? undefined : 'pt-lg tablet-sm:pt-lg'} data-sentry-element="ProfileContent" data-sentry-source-file="ProfileCard.tsx">
        <div className="flex min-w-0 flex-1 flex-col gap-md tablet-sm:flex-row tablet-sm:items-center">
          <ProfileAvatar avatarData={user.avatarData} className="shrink-0" data-sentry-element="ProfileAvatar" data-sentry-source-file="ProfileCard.tsx" />
          <ProfileUserInfo {...user} data-sentry-element="ProfileUserInfo" data-sentry-source-file="ProfileCard.tsx" />
        </div>
        <div className={'flex items-center gap-xs bg-transparent'}>
          {actions}
        </div>
      </ProfileContent>
    </ProfileContainer>;
};